export const SkillsData = [
  {
    type: 'Frontend',
    list: [
      {
        name: 'HTML5',
        icon: <i class="devicon-html5-plain colored"></i>
      },
      {
        name: 'CSS3',
        icon:  <i class="devicon-css3-plain colored"></i>
      },
      {
        name: 'Javascript',
        icon:  <i class="devicon-javascript-plain colored"></i>
      },
      {
        name: 'React JS',
        icon:  <i class="devicon-react-original colored"></i>
      },
      {
        name: 'Sass',
        icon:  <i class="devicon-sass-original colored"></i>
      },
      {
        name: 'Bootstrap',
        icon:   <i class="devicon-bootstrap-plain colored"></i>
      },            
    ]
  },
  {
    type: 'Design',
    list: [
      {
        name: 'Figma',
        icon:  <i class="devicon-figma-plain colored"></i>
      },
      {
        name: 'Adobe XD',
        icon:   <i class="devicon-xd-plain colored"></i>
      },
      {
        name: 'Photoshop',
        icon:    <i class="devicon-photoshop-plain colored"></i>
      },
      {
        name: 'Gimp',
        icon:    <i class="devicon-gimp-plain colored"></i>
      },
    ]
  },
  {
    type: 'Outhers',
    list: [
      {
        name: 'GitHub',
        icon:  <i class="devicon-github-plain colored"></i>
      },
      {
        name: 'Git',
        icon:   <i class="devicon-git-plain colored"></i>
      },
      {
        name: 'Heroku',
        icon:    <i class="devicon-heroku-plain colored"></i>
      },
      
      {
        name: 'NPM',
        icon:      <i class="devicon-npm-original-wordmark colored"></i>
      },
    ]
  },
]